import { ApplicationStepContainer } from '@/components/modules/Application/components/_shared/components/ApplicationStepContainer';
import { ApplicationStepNav } from '@/components/modules/Application/components/_shared/components/ApplicationStepNav';
import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { SectionTitle } from '@/components/modules/Application/components/_shared/components/Section/SectionTitle';
import { CartFormWrapper } from '@/components/modules/Application/components/Cart/DefaultCart/components/CartForm/CartFormWrapper';
import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const DefaultCart = () => {
  const { getTextIdTranslation } = useTranslation();
  const { cart, submitCart, disableSubmitCart, isCartFormValid, isReferenceValid } = useCart();
  const { arePaymentMethodsAvailable } = usePaymentMethods();
  const { onPrev } = useApplicationNavigation();

  return (
    <ApplicationStepContainer>
      <Section>
        <SectionTitle title={'CART'} subtitle={'CART_TEXT'} />
        <CartFormWrapper />
      </Section>
      <ApplicationStepNav
        onNext={submitCart}
        onPrev={onPrev}
        disableOnNext={disableSubmitCart || (cart?.validTotal() && !arePaymentMethodsAvailable(cart.total()).state)}
        tooltipOnNextDisabled={
          isReferenceValid
            ? getTextIdTranslation('DISABLED_TOOLTIP_CART_ERROR')
            : cart?.isReadyToSubmit() && isCartFormValid
            ? getTextIdTranslation('DISABLED_TOOLTIP_REFERENCE_ERROR')
            : getTextIdTranslation('DISABLED_TOOLTIP_REFERENCE_AND_CART_ERROR')
        }
      />
    </ApplicationStepContainer>
  );
};
